import { useEffect, useState } from 'react'

export default function useWinCombinations(
  state: number,
  player: string[],
  dealer: string[],
  playerType: number,
  dealerType: number,
) {
  const empty = ['0', '0', '0', '0', '0', '0', '0', '0', '0']
  const [winCombination, setWinCombination] = useState<string[]>(empty)
  const [winType, setWinType] = useState<number>(0)

  useEffect(() => {
    if (state === 5 || state === 4) {
      setWinCombination(player)
      setWinType(playerType)
    } else if (state === 6 && dealer[0] !== 'X0') {
      setWinCombination(dealer)
      setWinType(dealerType)
    } else {
        setWinCombination(empty)
        setWinType(0)
    }
  
  }, [state, player, dealer])

  return { winCombination, winType }
}
